import athenaConfig from '../../../config';
import FactorsList from '../../../components/factor-list/FactorsList';
import AmplitudeUtils from '../../../utils/amplitude-utils';
import FactorEnrollCustomizerBase from './base';
import React from 'react';
import { enrolledFactorsDuringEnrollment } from '../../../utils/widget-facade';
import EnrolledFactors from '../../../components/factor-list/oie/EnrolledFactors';
import { launchedFromLwaProfile } from '../../../utils/lwa-profile-utils';
import { launchedFromAthenanetUserProfile } from '../../../utils/athenanet-user-profile-utils';
import { getLocalizedString } from '../../../utils/i18n-utils';
import { OIE_ENROLLED_FACTOR_CONFIG } from '../../../constants';
import { PHONE_FACTOR_ENROLLMENT_EVENT_NAME } from '../../../constants';
import { isAnetUser } from '../../../utils/user-utils';
const { oieEnabled } = athenaConfig;
export default class FactorEnrollOieCustomizer extends FactorEnrollCustomizerBase {
  private isAnetUser: boolean = isAnetUser();
  async shouldCustomize() {
    return ((await super.shouldCustomize()) || this.context.formName === 'select-authenticator-enroll') && oieEnabled;
  }
  protected async forgifyController() {
    super.forgifyController();
    const enrolledFactorList = enrolledFactorsDuringEnrollment().filter((factor: any) => factor?.id?.startsWith('sms') || factor?.id?.startsWith('cl'));
    const moreThanOneSmsFactorEnrolled: boolean = enrolledFactorList?.filter((factor: any) => factor?.id?.startsWith('sms'))?.length > 1;
    const moreThanOneVoiceFactorEnrolled: boolean = enrolledFactorList?.filter((factor: any) => factor?.id?.startsWith('cl'))?.length > 1;
    if (!this.isAnetUser && (moreThanOneSmsFactorEnrolled || moreThanOneVoiceFactorEnrolled)) {
      AmplitudeUtils.logCustomEvent(PHONE_FACTOR_ENROLLMENT_EVENT_NAME, { workflow: 'MFAEnroll' });
    }
  }

  async customize() {
    if (launchedFromLwaProfile() || launchedFromAthenanetUserProfile()) {
      this.customizeForProfilePage();
    }
    else {
      await super.customize();
    }
  }

  forgifyFactors() {
    const oktaComponent = jQueryCourage('.authenticator-enroll-list');
    AmplitudeUtils.logCustomEvent('AthenanetMFAPrompt', {});
    let forgeComponent: React.JSX.Element;
    const enrolledFactors = enrolledFactorsDuringEnrollment()
      ?.map(({ key }: { key: string }) => key as keyof typeof OIE_ENROLLED_FACTOR_CONFIG);
    if (enrolledFactors?.length) {
      forgeComponent = (
        <>
          <EnrolledFactors enrolledFactors={enrolledFactors} title={getLocalizedString('enroll.choices.list.enrolled')} />
          <FactorsList
            oktaFactorsList={oktaComponent.find('.authenticator-row')}
            oktaSubmitButton={jQueryCourage('a.button-primary.button.skip-all.link-button')}
            title={getLocalizedString('enroll.choices.list.optional')}
            onClick={() => AmplitudeUtils.logMfaEnrollEvent('FinishButtonClick')}
          />
        </>
      );
    }
    else {
      forgeComponent = <FactorsList oktaFactorsList={oktaComponent.find('.authenticator-row')} />;
    }
    this.renderForgeAndHideOktaComponent({ id: 'authenticator-enroll-list', forgeComponent, oktaComponent });
  }

  private customizeForProfilePage() {
    jQueryCourage('.auth-content').css('opacity', '0');
    jQueryCourage('.authenticator-button a').eq(0)
      .trigger('click');
  }
}
